/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../enigma/service';
import '../binfo/api';
import '../payments/common';
import '../common/emv';
import '../common/tender';
import '../common/network_token';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "panhandler": {
        "nested": {
          "service": {
            "nested": {
              "ServerEncryptedTender": {
                "fields": {
                  "keyId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "wrappedKey": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  },
                  "encryptedTender": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardBin": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": "squareup.panhandler.service.TenderMetadata",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "TenderMetadata": {
                "fields": {
                  "fideliusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "readerInfo": {
                    "type": "squareup.enigma.service.ReaderInfo",
                    "id": 2,
                    "rule": "optional"
                  },
                  "binProperties": {
                    "type": "squareup.binfo.api.BinProperties",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tenderType": {
                    "type": "squareup.payments.common.TenderType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sanitizedEmvTags": {
                    "type": "squareup.common.EmvTags",
                    "id": 5,
                    "rule": "optional"
                  },
                  "verificationData": {
                    "type": "squareup.common.tender.VerificationData",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isPanValid": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "serviceCode": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "isCvvFormatValid": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "maskedPan": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "inputType": {
                    "type": "squareup.common.tender.TenderInputType",
                    "id": 12,
                    "rule": "optional"
                  },
                  "nameOnCard": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "tokenData": {
                    "type": "squareup.common.tender.TokenData",
                    "id": 14,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "transactionAmount": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "deviceManufacturerIdentifier": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "digitalWalletType": {
                    "type": "squareup.common.tender.DigitalWalletType",
                    "id": 19,
                    "rule": "optional"
                  },
                  "felicaBrandId": {
                    "type": "squareup.common.tender.FelicaCard.FelicaBrand",
                    "id": 20,
                    "rule": "optional"
                  },
                  "felicaTransactionId": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "originalTrack2Length": {
                    "type": "int32",
                    "id": 22,
                    "rule": "optional"
                  },
                  "cardOnFile": {
                    "type": "squareup.common.tender.CardOnFile",
                    "id": 23,
                    "rule": "optional"
                  },
                  "luhnStatus": {
                    "type": "squareup.payments.common.LuhnStatus",
                    "id": 24,
                    "rule": "optional"
                  },
                  "networkTokenData": {
                    "type": "squareup.common.NetworkTokenData",
                    "id": 25,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": "squareup.common.tender.AccountType",
                    "id": 27,
                    "rule": "optional"
                  },
                  "serverCompletedTender": {
                    "type": "squareup.common.tender.ServerCompleted",
                    "id": 28,
                    "rule": "optional"
                  },
                  "vendorReaderId": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "vendorReaderTransactionId": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "midGroup": {
                    "type": "string",
                    "id": 32,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.panhandler?.nested?.service?.nested?.ServerEncryptedTender && !$root.nested?.squareup?.nested?.panhandler?.nested?.service?.nested?.TenderMetadata) {
  $root.addJSON(jsonData);
}

/**
 * An encrypted CardTender message and the metadata needed to decrypt it
 *
 * SOURCE ServerEncryptedTender @ squareup/panhandler/service.proto at 447:1
 */
export const ServerEncryptedTender = $root.lookupType('squareup.panhandler.service.ServerEncryptedTender');
fixType(ServerEncryptedTender);
Builder.createAndAttachToType(ServerEncryptedTender);
/**
 * Card tender metadata
 *
 * SOURCE TenderMetadata @ squareup/panhandler/service.proto at 471:1
 */
export const TenderMetadata = $root.lookupType('squareup.panhandler.service.TenderMetadata');
fixType(TenderMetadata);
Builder.createAndAttachToType(TenderMetadata);